(function ($, document, window) {
	'use strict';

	function checkIfCaseStudyNavNeeded(lockOrUnlock, sliderElement, nav, bottomNav) {
		if ('lock' === lockOrUnlock) {
			nav.addClass('case-study-collection__carousel-nav--hidden');
			bottomNav.addClass('case-studies__nav--hidden');

			sliderElement.removeAttribute('role');
			sliderElement.removeAttribute('aria-label');
			sliderElement.removeAttribute('aria-roledescription');
		} else if ('unlock' === lockOrUnlock) {
			nav.removeClass('case-study-collection__carousel-nav--hidden');
			bottomNav.removeClass('case-studies__nav--hidden');

			sliderElement.setAttribute('role', 'region');
			sliderElement.setAttribute('aria-label', 'Posts Carousel');
			sliderElement.setAttribute('aria-roledescription', 'carousel');
		}
	}

	$(function () {
		$('.js-case-study-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navsContainer = $('.js-case-study-carousel-nav', sliderContainer);
			const paginationEl = $('.js-case-study-carousel-pagination', sliderContainer)[0];
			const bottomNav = $('.js-case-study-carousel-navs', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 16,
				slidesPerView: 'auto',
				loop: false,
				watchObserver: true,

				pagination: {
					el: paginationEl,
					type: 'bullets',
					clickable: true,
					bulletClass: 'case-studies__pagination-bullet pagination-bullet',
					bulletActiveClass: 'pagination-bullet--active pagination-bullet--active-black'
				},

				on: {
					lock: function () {
						checkIfCaseStudyNavNeeded('lock', sliderEl, navsContainer, bottomNav);
					},

					unlock: function () {
						checkIfCaseStudyNavNeeded('unlock', sliderEl, navsContainer, bottomNav);
					},

					slideChange: function () {
						if (this.isBeginning) {
							$('.js-carousel-nav-prev', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-prev', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd) {
							$('.js-carousel-nav-next', sliderContainer).addClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-next', sliderContainer).removeClass('carousel-nav__button--disabled');
							$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
						}
					},
				},
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
